import { useEffect, useState } from "react";
import { Printer, FileDown, X } from "lucide-react";
import { useSearchParams, useParams } from "react-router-dom";
import { getAuthHeaders } from "../services/useAuth";
import { BASE_URL } from "../config";
import { useRef } from "react";
import CustomButton from "../pages/CustomButton";

export default function StockistsTable() {
  const [stockists, setStockists] = useState([]);
  const [loading, setLoading] = useState(false);

  const { routeId } = useParams();
  const [searchParams] = useSearchParams();
  const tableRef = useRef(null);

  const employee_id = searchParams.get("employee_id");
  const count = searchParams.get("count");

  useEffect(() => {
    console.log(count, typeof(count))
    console.log(count == 0)
    if (!routeId || !employee_id || count == 0  ) return;

    fetchStockists();
  }, [routeId, employee_id]);

  const fetchStockists = async () => {
    try {
      setLoading(true);

      const response = await fetch(
        `${BASE_URL}/api/reports/employee-route-retailers?employee_id=${employee_id}&route_id=${routeId}&retailer_type=stockist`,
        {
          headers: getAuthHeaders(),
        },
      );

      const result = await response.json();

      setStockists(result.data || []);
    } catch (error) {
      console.error("Error fetching stockists:", error);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const handlePrint = () => {
    if (!tableRef.current) return;

    const printWindow = window.open("", "_blank", "width=1000,height=700");
    printWindow.document.write(`
    <html>
      <head>
        <title>Stockists Report</title>
        <style>
          body { font-family: Arial; padding:20px; }
          table { border-collapse: collapse; width:100%; }
          th, td { border:1px solid #000; padding:6px; font-size:12px; }
          th { background:#2563eb; color:white; }
        </style>
      </head>
      <body>
        ${tableRef.current.outerHTML}
      </body>
    </html>
  `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
  };

  const handleExportToExcel = () => {
    const headers = [
                    "S.No",
                    "Code",
                    "Stockist",
                    "PHONE",
                    "Address",
                    "HQ",
                    "State",
                    "City",
                  ];
    const rows = stockists.map((s, index) => [
      index + 1,
      s.code,
      s.name,
      s.mobile,
      s.address,
      s.headquarter,
      s.state,
      s.city,
    ]);

    let csvContent = headers.join(",") + "\n";

    rows.forEach((row) => {
      csvContent += row.map((cell) => `"${cell ?? ""}"`).join(",") + "\n";
    });

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "stockists.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const handleClose = () => {
    window.close();
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-lg text-gray-600">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-[1600px] mx-auto">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <div ref={tableRef}>
            <table className="w-full border-collapse">
              <thead className="bg-blue-500 text-white">
                <tr>
                  {[
                    "S.No",
                    "Code",
                    "Stockist",
                    "PHONE",
                    "Address",
                    "HQ",
                    "State",
                    "City",
                  ].map((h) => (
                    <th
                      key={h}
                      className="border border-gray-400 px-3 py-2 text-sm font-semibold text-left"
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {stockists.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="text-center py-4">
                      No stockists found
                    </td>
                  </tr>
                ) : (
                  stockists.map((stockist, idx) => (
                    <tr key={stockist.id} className="hover:bg-gray-50">
                      <td className="border px-3 py-2 text-sm">{idx + 1}</td>

                      <td className="border px-3 py-2 text-sm text-blue-600 font-medium">
                        {stockist.code}
                      </td>

                      <td className="border px-3 py-2 text-sm">
                        {stockist.name}
                      </td>

                      <td className="border px-3 py-2 text-sm">
                        {stockist.mobile || "-"}
                      </td>

                      <td className="border px-3 py-2 text-sm">
                        {stockist.address || "-"}
                      </td>

                      <td className="border px-3 py-2 text-sm">
                        {stockist.headquarter || "-"}
                      </td>

                      <td className="border px-3 py-2 text-sm">
                        {stockist.state || "-"}
                      </td>
                      <td className="border px-3 py-2 text-sm">
                        {stockist.city || "-"}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <div className="flex justify-center gap-3 p-4 bg-gray-50 border-t print:hidden">
            <CustomButton onClick={handlePrint} label="Print" variant="print">
              🖨
            </CustomButton>
            <CustomButton
              onClick={handleExportToExcel}
              label="Export"
              variant="export"
            >
              📥
            </CustomButton>
          </div>
        </div>
      </div>
    </div>
  );
}
